import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { 
  Users, Mail, BarChart, Target, 
  TrendingUp, Database, ArrowRight 
} from 'lucide-react';

const DigiCRMLanding = () => {
  const navigate = useNavigate();

  const features = [
    {
      icon: <Users className="w-8 h-8" />,
      title: "Contact Management",
      description: "Organize and manage all your contacts with smart categorization"
    },
    {
      icon: <Mail className="w-8 h-8" />,
      title: "Bulk Email Campaigns",
      description: "Send personalized emails to multiple contacts with custom templates"
    },
    {
      icon: <Target className="w-8 h-8" />,
      title: "Lead Tracking",
      description: "Track leads through your sales pipeline from prospect to customer"
    },
    {
      icon: <BarChart className="w-8 h-8" />,
      title: "Sales Pipeline",
      description: "Visualize your sales process and manage deals effectively"
    },
    {
      icon: <TrendingUp className="w-8 h-8" />,
      title: "Analytics & Reports",
      description: "Get insights into your business performance with detailed analytics"
    },
    {
      icon: <Database className="w-8 h-8" />,
      title: "Centralized Database",
      description: "All your customer data in one secure, accessible location"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-white to-slate-50">
      <div className="container mx-auto px-4 py-16">
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Digi<span className="text-green-600">CRM</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 mb-8 max-w-3xl mx-auto">
            Complete Customer Relationship Management for Growing Businesses
          </p>
          <div className="flex gap-4 justify-center flex-wrap">
            <Button
              onClick={() => navigate('/auth')}
              className="bg-green-600 hover:bg-green-700 text-white px-8 py-6 text-lg rounded-full"
            >
              Start Free Trial <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
            <Button
              onClick={() => navigate('/digi-crm')}
              variant="outline"
              className="px-8 py-6 text-lg rounded-full border-2 border-green-600 text-green-600 hover:bg-green-50"
            >
              View Demo
            </Button>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all border border-gray-100"
            >
              <div className="text-green-600 mb-4">{feature.icon}</div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-green-600 to-green-700 rounded-3xl p-12 text-center text-white">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Grow Your Business with Smart CRM
          </h2>
          <p className="text-xl mb-8 opacity-90">
            Join businesses managing their customer relationships better
          </p>
          <Button
            onClick={() => navigate('/auth')}
            className="bg-white text-green-600 hover:bg-gray-100 px-8 py-6 text-lg rounded-full font-semibold"
          >
            Get Started Today
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DigiCRMLanding;